import React, { useContext } from "react";
import clsx from "clsx";
import PageContext from "@PageContext";
import WebProfileContext from "@WebProfileContext";
import Metamenu from "./Metamenu";
import Micado from "./Micado";

import styles from "./Row2.styles";

const Row2 = () => {
	const [pageData] = useContext(PageContext);
	const [profileData] = useContext(WebProfileContext);
	const css = styles();

	const metamenu = pageData?.menuGroups?.find(item => item.title === "Metamenü");

	let copyrights = null;

	if (profileData && profileData.name) {
		copyrights = `© ${new Date().getFullYear()} ${profileData.name}`;
	}

	return (
		<div className={clsx(css.row2, "mco-view-component-footer-row2")}>
			<Micado />
			<Metamenu copyrights={copyrights} metamenu={metamenu} />
		</div>
	);
};

export default Row2;
